import React, { useEffect } from 'react';
import Modal, { ModalProps } from '@components/modal/Modal';
import { Button } from '@ftdr/blueprint-components-react';
import { getCurrentThemeConfig } from '@app/core/theme-config';

interface Props extends ModalProps {
  id: string;
  onConfirm: () => void;
  onClose?: () => void;
  yesText?: string;
  noText?: string;
  heading: string;
  canClose?: boolean;
}

const ModalChoice: React.FC<Props> = ({ id, heading, yesText, noText, canClose = true,
                                        onClose = canClose ? undefined : () => console.log("this modal can't be closed"), ...props }) => {
  const actions = [
    <Button key="submit" size="medium" label={yesText} onClick={() => props.onConfirm()}
      className={getCurrentThemeConfig().modalStyleButton}
      color={getCurrentThemeConfig().modalOkStyleButtonColor}/>,
  ];

  useEffect(() => {
      if (canClose) {
        actions.push(<Button
          key="cancel"
          className={getCurrentThemeConfig().modalStyleButton}
          color={getCurrentThemeConfig().modalOkStyleButtonColor}
          variant="ghost"
          size="medium"
          label={noText}
          onClick={() => onClose()}
        />,)
      }
  }, [canClose])

  return (
    <Modal id={id} heading={heading} hideClose={!canClose}  canClose={canClose} actions={actions} onClose={onClose} {...props}>
      {props.children}
    </Modal>
  );
};

ModalChoice.defaultProps = {
  yesText: 'Yes',
  noText: 'No',
};

export default ModalChoice;
